import { useQuery } from '@tanstack/react-query';
import { cartItemApi } from '@/api/commercial/cart-items';
import type { ICartCalculateResponse } from '@/types/commercial/cart';

export function useCartCalculate(proposalId?: string) {
  return useQuery<ICartCalculateResponse>({
    queryKey: ['cart-calculate', proposalId],
    queryFn: () => cartItemApi.calculate(proposalId!),
    enabled: !!proposalId,
  });
}
